import { Button } from '@mui/material';
import { MdCheck, MdClose } from 'react-icons/md';
import type { StagingRow } from '../../schema';

export interface ReviewRowActions {
  onApprove: (row: StagingRow) => void;
  onReject: (row: StagingRow) => void;
}

interface Props extends ReviewRowActions {
  row: StagingRow;
}

export function ReviewRowActionsCell({ row, onApprove, onReject }: Props) {
  return (
    <div className="flex h-full items-center justify-end gap-1.5">
      <Button
        size="small"
        variant="outlined"
        color="success"
        startIcon={<MdCheck size={16} />}
        onClick={() => onApprove(row)}
        sx={{ minWidth: 0, textTransform: 'none', px: 1.25 }}
      >
        Approve
      </Button>
      <Button
        size="small"
        variant="text"
        color="error"
        startIcon={<MdClose size={16} />}
        onClick={() => onReject(row)}
        sx={{ minWidth: 0, textTransform: 'none', px: 1 }}
      >
        Reject
      </Button>
    </div>
  );
}
